//import React, { useEffect, useState } from 'react';
//import { getAllTermStudents } from '../../services/studentService';

// import { Link } from "react-router-dom";
// import "./datatable.scss"
// import { DataGrid } from '@mui/x-data-grid';
// import { Button, Box  } from '@mui/material';
// export const StudentTermList=()=> {
//     const [expandedRows, setExpandedRows] = useState({});
//     const [students, setStudents] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const fetchAllTermStudents = async () => {
//         try {
//             const data = await getAllTermStudents();
//             console.log(data);
//             setStudents(data.data);
//         } catch (err) {
//             setError(err);
//         } finally {
//             setLoading(false);
//         }
//     };
//     useEffect(() => {      

//         fetchAllTermStudents();
//     }, []);



//     // Toggle the expanded state for the clicked row
//     const handleExpandToggle = (id) => {
//         setExpandedRows((prevExpandedRows) => ({
//             ...prevExpandedRows,
//             [id]: !prevExpandedRows[id],  // Toggle the specific row's expansion state
//         }));
//     };
//     const columns = React.useMemo(
//         () => [
//             { field: 'studentName', headerName: 'Student Name', width: 150 },
//             { field: 'enrollmentNumber', headerName: 'Enrollment Number', width: 150 },
//             { field: 'batch', headerName: 'Batch', width: 120 },
//             {
//                 field: 'actions',
//                 headerName: 'Actions',
//                 width: 150,
//                 renderCell: (params) => {
//                     const isExpanded = expandedRows[params.id] || false;  // Check if the row is expanded
//                     return (
//                         <Button onClick={() => handleExpandToggle(params.id)} variant="contained" size="small">
//                             {isExpanded ? "Hide Terms" : "Show Terms"}
//                         </Button>
//                     );
//                 },
//             },
//         ],
//         []
//     );
//     const getRowHeight = (params) => {
//         const isExpanded = expandedRows[params.id] || false;
//         return isExpanded ? 200 : 52;  // Set height to 200 when expanded, else default 52
//     };

//     // Custom rendering for expanded content
//     const renderExpandedRow = (row) => {
//         const isExpanded = expandedRows[row.id] || false;
//         console.log(row.id);
//         console.log(isExpanded);
//         if (isExpanded) {
//             return (
//                 <Box sx={{ marginTop: 2 }}>
//                     <strong>Terms:</strong>
//                     <ul style={{ listStyleType: 'none', padding: 0 }}>
//                         {row.terms.map((term) => (
//                             <li key={term.termId}>
//                                 <strong>{term.termName}</strong> - {term.status}
//                             </li>
//                         ))}
//                     </ul>
//                 </Box>
//             );
//         }
//         return null;
//     };
//     if (loading) return <p>Loading...</p>;
//     if (error) return <p>Error: {error.message}</p>;

//     const actionColumn = [{ field: "action", headerName:"Action", width:200,
//         renderCell:(params)=>{
//             const { id } = params.row;
//             return(
//                 <div className="cellAction">
//                     <div className="viewButton"><Link to={{pathname: `/instructors/view-instructor/${id}`}} style={{textDecoration:"none"}}>View</Link></div>
//                     <div className="editButton"><Link to={{pathname: `/instructors/edit-instructor/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>
//                 </div>
//             );
//         }
//     }]
//     const renderRow = (params) => {
//         const isExpanded = expandedRows.has(params.row.id);
//         return (
//             <div key={params.row.id} style={{ borderBottom: '1px solid #ccc', padding: '10px 0' }}>
//                 {/* Main Row Content */}
//                 <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                     <span>{params.row.studentName}</span>
//                     <span>{params.row.enrollmentNumber}</span>
//                     <span>{params.row.batch}</span>
//                     <Button onClick={() => handleExpandToggle(params.row.id)} variant="contained" size="small">
//                         {isExpanded ? "Hide Terms" : "Show Terms"}
//                     </Button>
//                 </div>

//                 {/* Expanded Content */}
//                 {isExpanded && (
//                     <div style={{ marginTop: 10, paddingLeft: 20 }}>
//                         <strong>Terms:</strong>
//                         <ul style={{ listStyleType: 'none', padding: 0 }}>
//                             {params.row.terms.map((term, index) => (
//                                 <li key={index}>
//                                     <strong>{term.termName}</strong> - {term.status}
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     return (
//         <div className="datatable" >
//         <div className="datatableTitle">


//           <Link to="/assignterms/new" className="link" >
//           Assign Student Terms
//           </Link>

//         </div>

//       <DataGrid 
//       rows={students}
//       columns={columns.concat(actionColumn)}
//       initialState={{
//         pagination: {
//           paginationModel: { page: 0, pageSize: 10 },
//         },
//       }}
//       pageSizeOptions={[5, 10]}
//       getRowId={(row) => row.id}  // Ensure unique ID for each row
//                 getRowHeight={getRowHeight}  // Adjust row height dynamically
//                 components={{
//                     // Render both the row and expanded content below each row
//                     Row: (props) => {

//                         const { row } = props;
//                         console.log(row);
//                         console.log("---")
//                         return (
//                             <div>
//                                 <div className="MuiDataGrid-row">{props.children}</div>
//                                 {renderExpandedRow(row)}
//                             </div>
//                         );
//                     }
//                 }}
//       //checkboxSelection
//     />
//   </div>
//     );
// }
import React, { useEffect, useState } from 'react';
import { getAllTermStudents } from '../../services/studentService';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import "./datatable.scss";
import { Link } from "react-router-dom";
import TablePagination from '@mui/material/TablePagination';

export const StudentTermList=()=> {
        const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };
  
    const fetchAllTermStudents = async () => {
        try {
            const data = await getAllTermStudents();
           // console.log(data);
            setStudents(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {      

        fetchAllTermStudents();
    }, []);




function Row(props) {
const { row } = props;
//console.log(row);
const [open, setOpen] = React.useState(false);

return (
<React.Fragment>
  <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
    <TableCell>
      <IconButton
        aria-label="expand row"
        size="small"
        onClick={() => setOpen(!open)}
      >
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </TableCell>
    <TableCell component="th" scope="row">
      {row.batch}
    </TableCell>
    <TableCell align="right">{row.enrollmentNumber}</TableCell>
    <TableCell align="right">{row.studentName}</TableCell>
  </TableRow>
  <TableRow>
    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ margin: 1 }}>
          <Typography variant="h6" gutterBottom component="div">
            Terms
          </Typography>
          <Table size="small" aria-label="purchases">
            <TableHead>
              <TableRow>
                <TableCell>Term Name</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row.terms.map((historyRow) => (
                <TableRow key={historyRow.termId}>
                  <TableCell component="th" scope="row">
                    {historyRow.termName}
                  </TableCell>
                  <TableCell>{historyRow.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Collapse>
    </TableCell>
  </TableRow>
</React.Fragment>
);
}

Row.propTypes = {
row: PropTypes.shape({
    batch: PropTypes.string.isRequired,
    enrollmentNumber: PropTypes.string.isRequired,
    studentName: PropTypes.string.isRequired,
}).isRequired,
};

  return (
    <div className="datatable" >
        <div className="datatableTitle">


          <Link to="/courses/new" className="link" >
          Add Course
          </Link>

        </div>
        <Paper sx={{ width: '100%' }}>
    <TableContainer >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Batch</TableCell>
            <TableCell align="right">Enrollment Number</TableCell>
            <TableCell align="right">Student Name</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {students.map((row) => (
            <Row key={row.id} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={students.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </div>
  );
}
